// extracted by mini-css-extract-plugin
module.exports = {"spotlight--flattened":"spotlight--flattened--qrwpw"};